import { Pipe, PipeTransform } from '@angular/core';
import { SafeAny } from '@pf/shared-common';

@Pipe({
    name: 'safeAny',
    standalone: false,
})
export class SafeAnyPipe<T extends SafeAny> implements PipeTransform {
    transform(value: T): SafeAny {
        return value as SafeAny;
    }
}
